import { useEffect } from "preact/hooks";
import { ChatScreen } from "./components/ChatScreen.jsx";
import { initConversation, getEntry } from "./hooks/useConversation.js";
import { isPushSupported, registerPushServiceWorker } from "./push/push.js";
import { listenForInstallPrompt } from "./push/installPrompt.js";

export function App() {
  useEffect(() => {
    initConversation();
    // El registro del SW es inofensivo sin permiso de notificaciones, pero
    // necesario antes de cualquier subscribe (y para la instalabilidad PWA).
    if (isPushSupported(getEntry())) registerPushServiceWorker();
    listenForInstallPrompt();
  }, []);

  return <ChatScreen />;
}
